export const amendedEmpowermentFinancingSettings = 'BEE/AmendedEmpowermentFinancingSettings/';

export const getConfiguration = amendedEmpowermentFinancingSettings + 'Configuration';
export const getSettings = (scorecardId: string) => amendedEmpowermentFinancingSettings + scorecardId;
export const saveSettings = amendedEmpowermentFinancingSettings;
